<template>
    <b-row class="match-height">
      <b-col lg="6"> <b-card
      title="Receive Purchase Order By Purchasing"
    >
      <b-form
          @submit.prevent="poCheck">
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="Purchase Order Number *"
              label-for="po_number"
              label-cols-md="4"
            >
              <b-form-input
                id="po_number"
                placeholder="Purchase Order Number"
                required="required"
                v-model="PurchaseOrderNumber"
              />
            </b-form-group>
          </b-col>
          <!-- submit and reset -->
          <b-col offset-md="4">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mr-1"
            >
              Submit
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
      </b-col>
    </b-row>
  </template>
  <script>
  import {
    BRow, BCol, BFormGroup, BFormInput, BForm, BModal, BButton, VBModal, BCard,
    } from 'bootstrap-vue'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import axios from 'axios'
  import moment from 'moment'

  const PurchaseOrderNumber = ''
  export default {
    components: {
      BModal,
      BCard,
      BRow,
      BCol,
      BFormGroup,
      BFormInput,
      BForm,
      BButton,
    },
    directives: {
      'b-modal': VBModal,
    },
    data() {
      return {
      PurchaseOrderNumber,
      }
    },
    methods: {
    poCheck() {
      const userToken = this.$cookies.get('userToken')
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userToken}`,
  }
        const body = {
          PurchaseOrderNumber: this.PurchaseOrderNumber,
        }
        const url = `${process.env.VUE_APP_API_URL}transactions/purchase_order/pre/receive/purchasing/check`
      axios
        .post(url, body, { headers })
        .then(response => {
          if (response.data.success === true) {
            if (this.hasPermission('purchase_order_receive_purchasing') === true && response.data.data.purchase_order_is_confirmed === true) {
                localStorage.setItem('poDetail', JSON.stringify(response.data.data))
                this.$router.push({ name: 'apps-purchase-order-receive-purchasing' })
            } else {
                if (response.data.data.purchase_order_is_received_by_purchasing !== null) {
                    this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'This PO Has been accepted by Purchasing',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                    })
                } else if (response.data.data.purchase_order_is_confirmed_by_laboratory_manager === null || response.data.data.purchase_order_is_confirmed_by_laboratory_manager === false) {
                    this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'You have no permission',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                    })
                }
            }
          } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          }
          })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Invoice Number Invalid!',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
      dateFormat(value, format = 'MM/DD/YYYY') {
          return moment(String(value)).format(format)
      },
    hasPermission(permission) {
      const permissions = this.$cookies.get('userPermissions').split(',')
      return permissions.includes(permission) ? true : false
    },
    },
  }
  </script>
